import { useEffect } from 'react';
import { EventRegister } from 'utils';

export const useWashHubListener = (handler: (washHubId: string) => void) => {
  useEffect(() => {
    const listener = (event: any) => {
      if (event?.detail && typeof event?.detail === 'string') {
        handler(event?.detail);
      }
    };

    EventRegister.subscribe('wash_hub_change', listener);

    return () => {
      EventRegister.unsubscribe('wash_hub_change', listener);
    };
  }, [handler]);
};
